import React from 'react';

import { IconActionCustomer } from '@cko/icons';

// TODO: Replace this icon when the icon will be added to the design system
export const Identities = () => {
  return <IconActionCustomer />;
};
